import Table from 'react-bootstrap/Table'
import { useState, useEffect } from 'react'
import { useEnunciadoContext } from '../context/enunciadoContext'
import api from '../components/api'
import { useVerificaDesafioContext } from '../context/verificaDesafioContext'
import { useSecaoEnunciadoContext } from '../context/secaoEnunciadoContext'
import moment from 'moment'

const Modal = (props) => {


    const [desafioValidacao_id, setDesafioValidacao_id] = useState()

    const { verificaDesafio, setVerificaDesafio } = useVerificaDesafioContext()
    const { secaoEnunciado, setSecaoEnunciado } = useSecaoEnunciadoContext()

    const adesao_institucional_id = props.adesao_institucional_id
    const ano = props.ano
    const formulario_id = props.formulario_id
    const origem = props.origem
    
    const [texto, setTexto] = useState('')

    const [observacao, setObservacao] = useState('')
    const [status, setStatus] = useState('')
    const { enunciado, setEnunciado } = useEnunciadoContext()

    const [questionamentos, setQuestionamentos] = useState([])
    const [totalQuestionamentos, setTotalQuestionamentos] = useState(0)

    const [desafioValidacaoQuest_id, setDesafioValidacaoQuest_id] = useState()


    const apaga = () => {
        

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'red',
		    title: 'Confirmação',
		    content: 'Confirma apagar?',
		    buttons: {
		        Sim: function () {


                        var dataPost = {

                            formulario_id: formulario_id,
                            secao: secaoEnunciado,
                            desafio: origem,
                            nome: sessionStorage.getItem('nome'),
                            us_codigo: sessionStorage.getItem('us_codigo'),

                        }


                        


                        api.put(`desafioValidaApaga/${desafioValidacao_id}`, dataPost).then((result) => {

                            console.log(result.data)
                            limpa()
                            //setVerificaDesafio(Math.random())
                            setVerificaDesafio(moment().format('YYYY-MM-DD HH:mm:ss'))
                            window.toastr.success('Registro salvo com sucesso!')
                            window.$('#modalValidacao').modal('hide')
                            //setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))

                        }).catch((err) => {

                            console.log(err.response)

                        })

                    }

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }


        });

    }


    const salva = () => {

        if (status == '') {

            window.toastr.error('<b>Situação</b> não pode ficar em branco')
            return false

        }

        if (observacao == '') {

            window.toastr.error('<b>Observação</b> não pode ficar em branco')
            return false

        }

        var item_id

        if (enunciado.indexOf('id: ') > -1) {

            var item_id_array = enunciado.split('id: ')
            var item_id = item_id_array[1]

        }

        var dataPost = {

            formulario_id: formulario_id,
            status: status,
            enunciado: enunciado,
            desafio: origem,
            observacao: observacao,
            secao: secaoEnunciado,
            item_id: item_id,
            nome: sessionStorage.getItem('nome'),
            us_codigo: sessionStorage.getItem('us_codigo'),

        }


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma os dados?',
		    buttons: {
		        Sim: function () {

                    if (desafioValidacao_id) {

                        api.put(`desafioValida/${desafioValidacao_id}`, dataPost).then((result) => {

                            //console.log(result.data)
                            
                            //setVerificaDesafio(Math.random())
                            setVerificaDesafio(moment().format('YYYY-MM-DD HH:mm:ss'))
                            window.toastr.success('Registro salvo com sucesso!')
                            window.$('#modalValidacao').modal('hide')
                            props.correcoes()
                            //setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))

                        }).catch((err) => {

                            console.log(err.response)

                        })

                    } else {


                        api.post(`desafioValida`, dataPost).then((result) => {

                            //console.log(result.data)
                            setDesafioValidacao_id(result.data[0].desafioValidacao_id)
                            //setVerificaDesafio(Math.random())
                            setVerificaDesafio(moment().format('YYYY-MM-DD HH:mm:ss'))
                            
                            //setResiduo_id(result.data[0].residuo_id)
                            window.toastr.success('Registro salvo com sucesso!')
                            window.$('#modalValidacao').modal('hide')
                            //setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                            props.correcoes()

                        }).catch((err) => {

                            
                            console.log(err, err.response)

                        })

                    }

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }

    const consultaId = () => {

        var dataPost = {

            enunciado: enunciado,
            formulario_id: formulario_id,
            desafio: origem,

        }

        //console.log('consulta id')
        //console.log(dataPost)
        //return false
        api.post('desafioPegaId', dataPost).then((result) => {

            //console.log(result.data)
            setDesafioValidacao_id(result.data[0]?.desafioValidacao_id ?? null)

        }).catch((err) => {

            console.log(err, err.response)

        })

    }

    const carregaDados = () => {

        if (desafioValidacao_id) {



            api.get(`desafioValidaUm/${desafioValidacao_id}`).then((result) => {

                //console.log(result.data)
                var data = result.data[0]
                
                setStatus(data.status)
                setObservacao(data.observacao)
                setSecaoEnunciado(data.secao)


            }).catch((err) => {

                console.log(err.response)

            })

        }

    }

    const apagaQuestionamento = async (desafioValidacaoQuest_id) => {

        //console.log(desafioValidacaoQuest_id)


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'red',
		    title: 'Confirmação',
		    content: 'Confirma apagar?',
		    buttons: {
		        Sim: function () {

                    

                        api.delete(`questionamento/${desafioValidacaoQuest_id}`).then((result) => {

                            window.toastr.success('Registro apagado com sucesso!')
                            carregaQuestionamentos()
                            
                        }).catch((err) => {

                            console.log(err.response)

                        })

                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

    }

    const carregaQuestionamentos = () => {

        if (desafioValidacao_id) {


            api.get(`questionamentos/${desafioValidacao_id}`).then((result) => {

                setTotalQuestionamentos(result.data.length)
                setQuestionamentos(result.data.map((rs) => 

                    <tr>
                        <td>
                            <div style={{ padding: 5}}>
                            <u>Em {rs.ad_new} por {rs.usuario}:</u>
                            <br/><br/>
                            {rs.texto}
                            
                            <div style={{ marginTop: 5, marginLeft: 5, textAlign: 'right'}}>
                                <div style={{ cursor: 'pointer'}} onClick={() => apagaQuestionamento(rs.desafioValidacaoQuest_id)}><font color="red">[Apagar]</font></div>
                                </div>
                            </div>
                        </td>
                        
                    </tr>

                ))


            }).catch((err) => {

                console.log(err.response)

            })


        }

    }


    const salvaResposta = () => {


        if (texto == '') {

            window.toastr.error('Por favor, informe o texto para salvar!')
            return false

        }


        var dataPost = {

            texto: texto,
            usuario: sessionStorage.getItem('nome'),
            
        }


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma salvar?',
		    buttons: {
		        Sim: function () {


                    if (desafioValidacaoQuest_id) {


                        api.put(`questionamento/${desafioValidacaoQuest_id}`, dataPost).then((result) => {

                            //console.log(result.data)
                            
                            //setVerificaDesafio(Math.random())
                            //setVerificaDesafio(moment().format('YYYY-MM-DD HH:mm:ss'))
                            window.toastr.success('Registro salvo com sucesso!')
                            setTexto('')
                            //window.$('#modalValidacao').modal('hide')
                            //props.correcoes()
                            //setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))

                        }).catch((err) => {

                            console.log(err.response)

                        })

                    } else {

                        //console.log('insere')
                        //return false

                        api.post(`questionamento/${desafioValidacao_id}`, dataPost).then((result) => {

                            //console.log(result.data)
                            //setDesafioValidacao_id(result.data[0].desafioValidacao_id)
                            //setVerificaDesafio(Math.random())
                            //setVerificaDesafio(moment().format('YYYY-MM-DD HH:mm:ss'))
                            
                            //setResiduo_id(result.data[0].residuo_id)
                            window.toastr.success('Registro salvo com sucesso!')
                            carregaQuestionamentos()
                            setTexto('')
                            //window.$('#modalValidacao').modal('hide')
                            //setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                            //props.correcoes()

                        }).catch((err) => {

                            console.log(err.response)

                        })

                    }

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }


    const limpa = () => {

        setStatus('')
        setObservacao('')
        setDesafioValidacao_id()
        setQuestionamentos('')
        setTexto('')

    }

    useEffect(() => {

        limpa()
        consultaId()

    }, [enunciado, formulario_id])

    
    useEffect(() => {

        carregaDados()
        carregaQuestionamentos()

    }, [desafioValidacao_id])


    return (

        <div>



            <div className="modal fade" id="modalValidacao" tabindex="-1" role="dialog">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Validação</h1>
                            </div>
                            <div class="modal-body">
                                    
                                    <div class="panel-body">


                                        <ul className="nav nav-tabs">
                                            <li  className="active"><a href="#tab1Q" data-toggle="tab">Apontamento</a></li>
                                            <li style={{ display: desafioValidacao_id ? 'table-row' : 'none' }} ><a href="#tab2Q" data-toggle="tab" onClick={() => {} } >Questionamentos ({totalQuestionamentos})</a></li>
                                            
                                            
                                            
                                        </ul>

                                        <div class="tab-content">
                                            <div class="tab-pane fade in active" id="tab1Q">
                                                <div class="panel-body">

                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <label>Questão</label>
                                                            <textarea className="form-control" value={enunciado} disabled={true} />
                                                                            
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <label>Seção</label>
                                                            <input className="form-control" value={secaoEnunciado} disabled={true} />
                                                                            
                                                        </div>
                                                    </div>
                                                    

                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <label>Situação</label>
                                                            <select className="form-control" value={status} onChange={event => setStatus(event.target.value)} >
                                                                <option value="">[Selecione]</option>
                                                                <option value="Erro">Com pendência</option>
                                                                <option value="Corrigido">Corrigido</option>
                                                            </select>
                                                                            
                                                        </div>
                                                    </div>
                                                    
                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <label>Observação</label>
                                                            <textarea className="form-control" rows="4" value={observacao} maxLength={3000} onChange={event => setObservacao(event.target.value)} />
                                                                            
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12" style={{ textAlign: 'right'}}>
                                                        <button style={{ display: desafioValidacao_id ? 'table-row' : 'none'}} type="button" className="btn btn-danger" onClick={() => apaga()}>Apagar</button>
                                                        <button style={{ marginLeft: 5}} type="button" className="btn btn-success" onClick={() => salva()}>Salvar</button>
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="tab-pane fade in" id="tab2Q">
                                                <div class="panel-body">

                                                    
                                                    <div className="row">                               



                                                        <div className="col-md-12">


                                                            
                                                                <Table striped bordered hover>
                                                                    <tbody>
                                                                    {questionamentos}
                                                                    </tbody>
                                                                    
                                                                </Table>
                                                        

                                                        </div>

                                                        <div class="col-md-12">
                                                            <div class="form-group">
                                                                <label>Resposta</label>
                                                                <textarea className="form-control" value={texto} rows="3" maxLength={1000} onChange={event => setTexto(event.target.value)} placeholder='Máx. 1.000 caracteres' />
                                                                                
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12" style={{ textAlign: 'right'}}>
                                                            
                                                            <button style={{ marginLeft: 5}} type="button" className="btn btn-success" onClick={() => salvaResposta()}>Salvar resposta</button>
                                                        </div>

                                                    </div>




                                                </div>
                                            </div>
                                        </div>



                                        
                                        
                                    </div>


                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>


        </div>
    )

}

export default Modal